import { apiGet } from "../../utils"

export function musiclinkAPI(input) {
    return apiGet('/api/musiclink', { url: input })
}

export function fetchLogosAPI() {
    return apiGet('/api/logos')
}
